import anime from 'animejs/lib/anime.es.js';

export default function(el) {
	return new Promise(resolve => {
		const animation = anime({
			targets: el,
			opacity: [0, 1],
			easing: 'linear',
			duration: 500,
		});

		animation.finished.then(resolve);
	});
}
